export default "__VITE_ASSET__985be860__"